import type { IAssetMinimal } from "../../../../../types/models/asset.models.types";
import { usePostFormDataHttp } from "../../../http.hook";

interface IResponse {
  asset: IAssetMinimal;
}

export function useCreateAssetCommonHttp() {
  return usePostFormDataHttp<IResponse>({
    path: "/common/utils/assets",
  });
}
